import { getLocalStorage } from './local-storage';

import { DEFAULT_DOMESTIC_CURRENCY, SUPPORTED_LOCALES } from './constants';
import { getBrowserLocales } from './getBrowserLocales';

export const getDomesticCurrency = () => {
  return getLocalStorage('domesticCurrency') || DEFAULT_DOMESTIC_CURRENCY;
};

export const getCurrencySymbol = (currency: string | null = null): string => {
  const browserLocales = getBrowserLocales();
  const domesticCurrency = getDomesticCurrency();

  try {
    const locale =
      !!browserLocales?.[0] && SUPPORTED_LOCALES.includes(browserLocales?.[0])
        ? browserLocales?.[0]
        : 'en-US';

    return (
      new Intl.NumberFormat(locale, {
        style: 'currency',
        currency: currency || domesticCurrency,
        currencyDisplay: 'symbol',
      })
        .formatToParts(0)
        .find((part) => part.type === 'currency')?.value || '$'
    );
  } catch (error) {
    // Fallback to $ if currency formatting fails
    return '$';
  }
};
